import { FC } from "react";
import { EnvironmentsListHeader } from "./EnvironmentsListHeader";
import { EnvironmentsListItem } from "./EnvironmentsListItem";
import { IEnvironment } from "../../../interfaces";
import "./style.css";

interface Props {
  envs: IEnvironment[];
  headers: {
    label: string;
    onClick?: () => void;
  }[];
}

export const EnvironmentsList: FC<Props> = ({ envs, headers }) => {
  return (
    <>
      <EnvironmentsListHeader headers={headers} />
      <tbody>
        {envs.map((env, index) => (
          <EnvironmentsListItem key={env?.name} env={env} index={index} />
        ))}
      </tbody>
    </>
  );
};
